import React, {  memo } from 'react'
import { withTranslation } from 'react-i18next'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import useStyles from './filesComponentStyle'
import {
  Search as SearchIcon,
  GetApp as SaveIcon,
  FileCopyRounded as FileIcon,
  FindInPageRounded as InfoIcon,
} from '@material-ui/icons'
import IconButton from '../../atoms/inputs/iconButton'
import AudioPlayer from '../../atoms/feedback/audioPlayer'
import { setGalleryOpen } from '../../../redux/gallery/actions'
import { setTicketFiles } from '../../../redux/ticketGallery/actions'
import handleDownload from '../../../utils/downloadFile'
import Typography from '../../atoms/display/typography'

const RenderFiles = ({ history = false, small= false}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const size = useSelector((state) => state.preferences)
  let useStylesParams = {
    size: small,
  }
  const classes = useStyles(useStylesParams)
  const theme = useTheme()
  let counter = 0;
  let tempIndex;

  return (
    <Box style={{ marginTop: '1em', fontSize: 18 }} sx={{ width: '100%' }}>
      <div className={classes.documentsStyle} style={{ padding: 0 }}>
        {history.length > 0 ? (
          history.length > 0 && history?.map((file, idx) =>
          file?.mime_type?.split('/')[0] === 'audio' && file?.file_url ? (
            <div className={classes.documentsAudio} key={idx}>
              <AudioPlayer
                style={{ padding: '0.1em' }}
                src={file?.file_url}
                type={file?.mime_type?.split(';')[0]}
              />
            </div>
          ) : file?.mime_type?.split('/')[0] === 'image' ? (
            file.index = counter,
            counter++,
            <div
              key={idx}
              style={{display: 'flex', 
              flexDirection: small ? 'column' : 'row',
              alignItems: small && 'center',
              background: "#203c71",
              borderRadius: '1em',
              margin: '0.5em',
              padding: '1em',
              textDecoration: "none",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
              transition: 'all 200ms ease-in-out',
              '&:hover':{
                background: "#142f64",
                boxShadow: "rgba(0, 0, 0, 0.35) 5px 10px 25px",
                cursor: "pointer"
              }}}
            >
              <img
                style={{ 
                  padding: '0.1em',
                  width: small && '70%',
                }}
                className={classes.picture}
                src={file?.file_url}
                alt=""
                onClick={() => {
                  let tempIndex = file?.index;
                  dispatch(setTicketFiles({history,tempIndex}))
                  dispatch(setGalleryOpen(true))
                }}
              />
              <div
              style={{
                display: small && 'flex',
                alignItems: small && 'center',
                flexDirection: small && 'column-reverse',
              }}
              >
                <Typography
                  className={classes.labelTicket}
                  style={{
                    background: '#31757A',
                    padding: '1em',
                    marginTop: '1em',
                    width:'100%',
                    wordWrap: small === true && 'break-word',
                    maxWidth: small === true && '70%',
                  }}
                >
                  {file?.file_name}
                </Typography>
              </div>
                <div style={{ marginLeft: !small && '4.5em', display: small && 'flex' }}>
                  <IconButton onClick={() => {
                    let tempIndex = file?.index;
                    dispatch(setTicketFiles({history,tempIndex}))
                    dispatch(setGalleryOpen(true))
                  }}>
                    <SearchIcon
                      style={{ color: theme.palette.primary.main }}

                    />
                  </IconButton>
                  <IconButton  onClick={() =>
                    handleDownload(file?.file_url, file?.file_name)
                  }>
                    <SaveIcon
                      style={{ color: theme.palette.primary.main }}
                    />
                  </IconButton>
                </div>
            </div>
          ) : (
            <div
              key={idx}
              style={{display: 'flex', 
              flexDirection: small ? 'column' : 'row',
              alignItems: small && 'center',
              background: "#203c71",
              borderRadius: '1em',
              margin: '0.5em',
              padding: '1em',
              textDecoration: "none",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
              transition: 'all 200ms ease-in-out',
              '&:hover':{
                background: "#142f64",
                boxShadow: "rgba(0, 0, 0, 0.35) 5px 10px 25px",
                cursor: "pointer"
              }}}
            >
              <FileIcon
                className={classes.documentIcon}
                onClick={() => handleDownload(file?.file_url, file?.file_name)}
              />
              <div
                style={{
                  display: small && 'flex',
                  alignItems: small && 'center',
                  flexDirection: small && 'column-reverse',
                  width: !small && '373px',
                }}
              >
                <Typography
                  className={classes.labelTicket}
                  style={{
                    background: '#31757A',
                    padding: '1em',
                    marginTop: '1em',
                    width: !small && '367.75px',
                    wordWrap: small === true && 'break-word',
                    maxWidth: small === true && '70%',
                  }}
                >
                  {file?.file_name}
                </Typography>
              </div>
                <div style={{ marginLeft: !small && '4.3em', display: small && 'flex' }}>
                  <IconButton  onClick={() =>
                    handleDownload(file?.file_url, file?.file_name)
                  }>
                    <SaveIcon
                      style={{ color: theme.palette.primary.main }}
                    />
                  </IconButton>
                </div>
            </div>
          ))
        ):(
          <div
            style={{
              display:'flex',
              alignItems:'center',
              justifyContent:'center',
              flexDirection:'column'
            }}
          >
            <div style={{
              width: '60px',
              height: '60px',
              background: '#009EE2',
              borderRadius: '50%',
              textAlign: 'center',
              fontSize: '14px',
              color:"#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom:'1em'
            }}>
              <InfoIcon></InfoIcon>
            </div> 
            <Typography style={{
              textAlign: 'center',
              maxWidth: '200px',
              wordWrap: 'breakWord',
            }}>
              {t('commons.thereIsNoDocumentsAttachedToThisTicket')}
            </Typography>
          </div>
        )
      }
      </div>
    </Box>
  )
}

export default withTranslation()(memo(RenderFiles))
